<template>
  <div class="form-item">
    <p class="form-label">{{ label }}</p>
    <input
      v-if="type === 'text'"
      class="form-text-input"
      :placeholder="placeholder"
      type="text"
      v-model="data"
    />
    <textarea
      class="form-text-input h-full resize-none"
      v-if="type === 'textarea'"
      :placeholder="placeholder"
      name=""
      id=""
      cols="30"
      rows="10"
      v-model="data"
    ></textarea>
    <p class="err-msg" v-if="error">{{ errorMsg }}</p>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const emit = defineEmits(['update:value'])
const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  error: {
    type: Boolean,
    default: false,
  },
  errorMsg: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  value: {
    type: String,
    default: '',
  },
})

const data = computed({
  get: () => props.value,
  set: (val) => emit('update:value', val),
})
</script>

<style scoped lang="postcss">
.form-item {
  @apply;
}

.form-label {
  @apply text-left mb-[14.61px] text-[22px] leading-[25.78px];
  @apply <tablet:(mb-[3.75px] leading-[20.27px] text-[14px]);
}

.form-text-input {
  @apply border-2 border-[#DDDDDD] outline-none rounded-[10px] p-[11px] w-full text-[20px] leading-[23.44px] tracking-[1.5px];
  @apply <tablet:(text-[14px] py-2);
}

.err-msg {
  @apply text-[#dc3232] text-[14px] text-left mt-[5px];
  @apply <tablet:(text-[12px]);
}
</style>
